import React from "react";

import { Container } from "./styles";

function Input({
  id,
  label,
  placeholder,
  options,
  mensagemErro,
  handler,
  required,
}) {
  return (
    <Container>
      <label>{label}</label>
      <div>
        {options.map((o, i) => (
          <span key={i}>
            <input
              id={o.id}
              name={id}
              type="radio"
              defaultChecked={o.default}
              value={o.value}
              onChange={handler}
            />
            <label htmlFor={o.id}>{o.label}</label>
          </span>
        ))}
      </div>
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default Input;
